import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { AuditTokenService } from './audit-token.service';

@Injectable({
  providedIn: 'root',
})

export class AuditAuthStateService {
  private userState = new BehaviorSubject<boolean>(this.token.isLoggedIn()!);
  userAuthState = this.userState.asObservable();
  constructor(public token: AuditTokenService) {}
  setAuthState(value: boolean) {
    this.userState.next(value);
  }
}